<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4">
          <department
            :class-padding="classPadding"
            :title="'Departments'"
            :label="'Department'"
            v-model="selectedDep"
            :code-value="false"
          ></department>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="classPadding" v-if="items.length > 0">
      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="4"
          md="4"
          offset-md="8"
          offset-sm="8"
          :class="classPadding"
        >
          <v-text-field
            label="Search"
            v-model="searchQuery"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="items"
        item-key="empCode"
        show-select
        class="elevation-1"
        v-model="selectedEmployee"
        :footer-props="footerProps"
        :search="searchQuery"
      >
        <template v-slot:header.data-table-select>
          <v-checkbox
            @change="toggleAll"
            color="default"
            v-model="selectAll"
            value
          />
        </template>
      </v-data-table>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-checkbox
            v-model="filter"
            label="Without Department Filter"
            :class="classPadding"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="loading"
            @click.prevent="add"
            v-if="userAccess.add >= 1"
            >Add</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table
        :items="approvers"
        :headers="approversH"
        v-if="approvers.length > 0"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click.stop="deleteItem(item)" text icon v-if="userAccess.delete >= 1">
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import Department from "../../setup/employment-info/organizational-level/department/Lookup";
import { isNullOrUndefined } from "../../../validation/validation";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/emailNotifPerDep";
export default {
  metaInfo: {
    title: "Email Notification Recipient Per Department",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Email Notification Recipient Per Department",
    classPadding: "my-0 py-0",
    selectedDep: {},
    items: [],
    headers: [
      { text: "Emp Code", value: "empCode", sortable: false },
      { text: "Name", value: "fullName", sortable: false }
    ],
    selectedEmployee: [],
    footerProps: {
      itemsPerPageOptions: [5, 10, 25, 50]
    },
    searchQuery: "",
    selectAll: false,
    filter: true,
    approvers: [],
    approversH: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false
      },
      {
        text: "Email Address",
        value: "email",
        sortable: true
      }
    ],
    selectedEmpCodes: [],
    loading: false
  }),
  components: {
    Department
  },
  methods: {
    filterEmployee() {
      var data = {
        DepCode: this.selectedDep.code,
        Filter: this.filter
      };
      this.$axios
        .post(`${API_ENDPOINT}/filter`, data)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedEmployee = this.items.slice();
      } else {
        if (this.selectedEmployee.length) {
          this.selectedEmployee = [];
        } else {
          this.selectedEmployee = this.items.slice();
        }
      }
    },
    getApprovers(depCode) {
      this.$axios
        .get(`${API_ENDPOINT}/approvers/${depCode}`)
        .then(({ data }) => {
          this.approvers = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.depCode}/${item.empCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.getApprovers(item.depCode);
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    add() {
      this.loading = true;
      var data = {
        EmpCodeList: this.selectedEmpCodes,
        DepCode: this.selectedDep.code
      };
      this.$axios
        .post(`${API_ENDPOINT}`, data)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
          this.getApprovers(this.selectedDep.code);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.selectedEmployee = [];
      this.selectedEmpCodes = [];
    }
  },
  watch: {
    selectedDep(val) {
      if (!isNullOrUndefined(val.code)) {
        this.filterEmployee();
        this.getApprovers(val.code);
      } else {
        this.filterEmployee();
        this.approvers = [];
      }
    },
    filter() {
      this.filterEmployee();
    },
    selectedEmployee(val) {
      if (val.length !== this.items.length) this.selectAll = false;
      else this.selectAll = true;

      var empCodes = val.map(function(item) {
        return item.empCode;
      });
      this.selectedEmpCodes = empCodes;
    }
  },
  created() {
    this.filterEmployee();

    this.getUserAccessRights("EMFSRecip");
  }
};
</script>